export default __webpack_public_path__ + "static/media/MW.0d3e1101.svg";